export const RemovalReasonTypeExcelHeader = [
  {
    header: "REMOVAL REASON TYPE CODE",
    key: "REMOVAL REASON TYPE CODE",
  },
  {
    header: "REMOVAL REASON TYPE NAME",
    key: "REMOVAL REASON TYPE NAME",
  },
  {
    header: "IS REQUIRED",
    key: "IS REQUIRED",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const RemovalReasonTypeExcelName = "Removal Reason Type List";
